import {Theme} from '@material-ui/core';
import {makeStyles} from '@material-ui/styles';
import React, {useState} from 'react';
import useRouter from 'use-react-router';
import {LoadingOverlay} from '../../../components/LoadingOverlay/LoadingOverlay';
import {Page} from '../../../components/Page';
import PageHeader from '../../../components/PageHeader';
import SearchBar from '../../../components/SearchBar';
import {CmsCopy, OPERATOR, WhereConstraints} from '../../../graphql/common.datatypes';
import getCmsCopys from '../getCmsCopys.api';
import Results from './Results';

const useStyles = makeStyles((theme: Theme) => ({
    root: {
        padding: theme.spacing(3)
    },
    results: {
        marginTop: theme.spacing(3)
    }
}));

export const CmsCopyListContent = () => {
    const classes = useStyles();
    const [rowsPerPage, setRowsPerPage] = useState(50);
    const [page, setPage] = useState(1);
    const [orderBy] = useState([{column: 'key', order: 'ASC'}]);
    const [selectedCmsCopy, setSelectedCmsCopy] = useState<CmsCopy | undefined>();

    const [where, setWhere] = useState({});
    const cmsCopysData = getCmsCopys(rowsPerPage, page, where, orderBy);

    const handleSearch = (value: string) => {
        const whereConstraints: WhereConstraints = {
            OR: [
                {column: 'key', operator: OPERATOR.LIKE, value: `%${value}%`},
                {column: 'body', operator: OPERATOR.LIKE, value: `%${value}%`},
            ],
        };
        setWhere(whereConstraints);
    };

    return (
        <React.Fragment>
            <SearchBar onSearch={handleSearch}/>
            <LoadingOverlay loading={cmsCopysData.loading}>
                {cmsCopysData.data && cmsCopysData.data.cmsCopys && cmsCopysData.data.cmsCopys.data && (
                    <Results
                        className={classes.results}
                        cmsCopys={cmsCopysData.data.cmsCopys.data}
                        paginatorInfo={cmsCopysData.data.cmsCopys.paginatorInfo}
                        selectedCmsCopy={selectedCmsCopy}
                        setSelectedCmsCopy={setSelectedCmsCopy}
                        setPage={setPage}
                        rowsPerPage={rowsPerPage}
                        setRowsPerPage={setRowsPerPage}
                    />
                )}
            </LoadingOverlay>
        </React.Fragment>
    );
};

const CmsCopyList = () => {
    const classes = useStyles();
    const title = 'CMS Copy';
    const {history} = useRouter();

    const handleNewGroup = () => {
        history.push('/cms_copy/new');
    };

    return (
        <Page className={classes.root} title={title}>
            <PageHeader section="cms" title={title} action={{
                permission: 'cms_copy.create',
                label: 'Add CMS Copy',
                onClick: handleNewGroup,
            }}/>
            <CmsCopyListContent/>
        </Page>
    );
};

export default CmsCopyList;
